import { Component, OnInit } from '@angular/core';
import { accordionInterface } from 'src/app/util/interfaces/accordion';
import { CustomAccordionService } from './service/custom-accordion.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ReportPageService } from 'src/app/page/report/service/report-page.service';
import { mspTableHeaderI, MspTableComponent } from 'src/app/page_component_item/msp-table/msp-table.component';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ReportFormService } from 'src/app/page/report/report-form/service/report-form.service';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { CommonModule } from '@angular/common';
import { SearchFilterComponent } from 'src/app/page_component/search-filter/search-filter.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	standalone: true,
	imports: [CommonModule, DotBounceLoadingEffectModule, InputWithAutocompleteModule, MspTableComponent, SearchFilterComponent],
	selector: 'register-form-custom-accordion',
	templateUrl: './custom-accordion.component.html',
	styleUrls: ['./custom-accordion.component.scss'],
})
export class CustomAccordionComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_geral_nome: '',
		lbl_geral_parametros: '',
		lbl_geral_buscar: '',
		lbl_kb_criar: '',
		lbl_geral_atualizar: '',
		lbl_geral_limpar_campos: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_removido_com_sucesso: '',
		lbl_geral_excluir: '',
		lbl_clique_confirmar_acao: '',
		lbl_poucos_parametros_aumentam_tempo_busca: '',
		lbl_preencha_nome: '',
		lbl_selecione_no_minimo_um_parametro: '',
		lbl_rep_custom_id_32: '',
		lbl_aguarde_processamento_demorar: '',
		lbl_action_reload_page: '',
		lbl_geral_voltar: '',
		lbl_geral_listagem: '',
	};

	accordionForm: genericFormInterface[] = [];
	baseAccordionForm: genericFormInterface[] = [];
	accordionFormDictionary = {};

	constructor(
		private LabelsService: LabelsService,
		private CustomAccordionService: CustomAccordionService,
		private NotificationService: NotificationService,
		private ReportPageService: ReportPageService,
		private ProfileService: ProfileService,
		private ReportFormService: ReportFormService
	) {}

	isLoadingAccordionForm = true;
	isLoadingAccordion = true;
	isLoadingLabels = true;
	isUpdatingAccordion = false;
	isDeletingAccordion = false;
	isLoadingParams = true;

	userAccordion: accordionInterface[] = [];
	userAccordionIAC: iacOptionInterface[] = [];
	userAccordionDictionary = {};

	searchHeader: mspTableHeaderI[] = [{ name: 'name', value: 'lbl_geral_nome', colType: 'text' }];
	selectedAccordion: accordionInterface = {
		id: '-1',
		name: '',
		type: 'custom',
		dataType: 'request',
		alert: undefined,
		border: undefined,
		params: [],
		accordionLength: 0,
		hidden: false,
	};

	mandatoryFilters: string[] = [];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.CustomAccordionService.getUserAccordion().subscribe((accordion) => {
			this.userAccordion = accordion;
			for (const accordion of this.userAccordion) {
				this.userAccordionDictionary[accordion.id] = accordion;
				const accordionIAC: iacOptionInterface = {
					name: accordion.name,
					value: accordion.id,
				};

				this.userAccordionIAC.push(accordionIAC);
			}
			this.isLoadingAccordion = false;
		});

		this.NotificationService.setNotificationMessage(this.labels.lbl_aguarde_processamento_demorar);
		const parameterType = this.ProfileService.userData().sessionStatus == 1 ? 'fullRequest' : 'enduserRequest';

		if (parameterType == 'enduserRequest') this.mandatoryFilters = ['contracted_solution_areas', 'active'];

		this.CustomAccordionService.getFormOptions(parameterType, true).subscribe((form) => {
			this.accordionForm = JSON.parse(JSON.stringify(form)).filter((formItem) => formItem.name !== 'customer');
			this.baseAccordionForm = JSON.parse(JSON.stringify(form)).filter((formItem) => formItem.name !== 'customer');
			for (const formItem of this.accordionForm) {
				this.accordionFormDictionary[formItem.name] = formItem;
			}
			this.isLoadingParams = false;
		});
	}

	resetForm(): void {
		this.isLoadingAccordionForm = true;
		this.selectedAccordion = {
			id: '-1',
			name: '',
			type: 'custom',
			dataType: 'request',
			alert: undefined,
			border: undefined,
			params: [],
			accordionLength: 0,
			hidden: false,
		};
		this.accordionForm = JSON.parse(JSON.stringify(this.baseAccordionForm));
		this.accordionFormDictionary = {};
		for (const formItem of this.accordionForm) {
			this.accordionFormDictionary[formItem.name] = formItem;
		}
		setTimeout(() => {
			this.isLoadingAccordionForm = false;
		}, 1);
	}

	setSelectedOnForm(): void {
		this.isLoadingAccordionForm = true;
		for (const parameter of this.selectedAccordion.params) {
			const selectedField = <genericFormI>this.accordionFormDictionary[parameter.param_name];
			selectedField.selected = true;
			this.CustomAccordionService.getFormItem(selectedField.name).subscribe((formItems) => {
				if (formItems.length > 0 && selectedField.inputType != 'boolean') {
					selectedField.items = formItems;
					if (parameter.param_type == 'multi-select') {
						selectedField.inputType = 'multi-select';
						selectedField.rawInputType = 'multi-select';
						for (const item of selectedField.items) {
							if (parameter.param_value.split(',').includes(item.values[0]?.toString())) {
								selectedField.values.push(item);
								selectedField.rawValues.push(item.values[0]);
							}
						}
					}
				} else if (selectedField.inputType == 'boolean' || selectedField.inputType == 'checkbox') {
					selectedField.values[0] = Number.parseInt(parameter.param_value);
				} else if (selectedField.inputType == 'period-date') {
					selectedField.values = parameter.param_value.split(',');
					selectedField.periodType =
						<any>new Date(selectedField.values[0]) == 'Invalid Date' ? selectedField.values[0] : 'period';
				} else {
					selectedField.values[0] = parameter.param_value;
				}
			});
			setTimeout(() => {
				this.isLoadingAccordionForm = false;
			}, 1);
		}
	}

	setSelectedAccordionParams(form: any): void {
		form = JSON.parse(form);
		this.selectedAccordion.params = [];

		form.forEach((formItem: genericFormInterface) => {
			this.CustomAccordionService.getFormItem(formItem.name).subscribe((itemsParameter) => {
				const selectedForm = <genericFormInterface>this.accordionFormDictionary[formItem.name];
				formItem.items = itemsParameter;

				if (formItem.items.length > 0 && formItem.inputType != 'boolean') {
					selectedForm.items = formItem.items;
					selectedForm.inputType = 'multi-select';
					selectedForm.rawInputType = 'multi-select';
				}
			});

			if (formItem.inputType == 'period-date') {
				formItem.periodType = <any>new Date(formItem.values[0]) == 'Invalid Date' ? formItem.values[0] : 'period';
			}

			if (formItem.rawValues?.length > 0 && formItem.rawValues[0] != '') {
				const temporary = {
					param_name: formItem.name,
					param_value: formItem.rawValues.join(','),
					param_type: formItem.inputType,
				};
				this.selectedAccordion.params.push(temporary);
			} else {
				const temporary = {
					param_name: formItem.name,
					param_value: formItem.rawValues.join(',') ? formItem.rawValues.join(',') : formItem.values.join(','),
					param_type: formItem.inputType,
				};
				this.selectedAccordion.params.push(temporary);
			}
		});
	}

	createCustomAccordion(): void {
		if (this.isUpdatingAccordion) return;

		if (this.selectedAccordion.name == '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_nome);
			return;
		} else if (this.selectedAccordion.params.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_no_minimo_um_parametro);
			return;
		} else {
			this.isUpdatingAccordion = true;
			this.CustomAccordionService.createCustomAccordion(this.selectedAccordion).subscribe({
				next: (res) => {
					this.selectedAccordion.id = res.id;
					this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
					this.userAccordion.push(JSON.parse(JSON.stringify(this.selectedAccordion)));
					this.userAccordionDictionary[res.id] = JSON.parse(JSON.stringify(this.selectedAccordion));
					this.userAccordionIAC.push({ name: this.selectedAccordion.name, value: res.id });
				},
				complete: () => {
					this.isUpdatingAccordion = false;
					this.isLoadingAccordion = true;
					setTimeout(() => {
						this.isLoadingAccordion = false;
					}, 10);
				},
			});
		}

		this.NotificationService.setNotificationMessage(this.labels.lbl_action_reload_page);
		location.reload();
	}

	updateCustomAccordion(): void {
		if (this.isUpdatingAccordion || this.isDeletingAccordion) return;

		if (this.selectedAccordion.name == '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_nome);
		} else if (this.selectedAccordion.params.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_no_minimo_um_parametro);
		} else {
			this.isUpdatingAccordion = true;
			this.CustomAccordionService.updateCustomAccordion(this.selectedAccordion).subscribe({
				next: () => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				},
				complete: () => {
					this.isUpdatingAccordion = false;
					this.isLoadingAccordion = true;
					setTimeout(() => {
						this.isLoadingAccordion = false;
					}, 10);
				},
			});
		}

		this.NotificationService.setNotificationMessage(this.labels.lbl_action_reload_page);
		location.reload();
	}

	deleteCustomAccordion(): void {
		if (this.isUpdatingAccordion || this.isDeletingAccordion) return;
		this.isDeletingAccordion = true;
		this.CustomAccordionService.deleteCustomAccordion(this.selectedAccordion.id).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
				for (const [index, accordion] of this.userAccordionIAC.entries()) {
					if (accordion.value == this.selectedAccordion.id) {
						this.userAccordionIAC.splice(index, 1);
						this.resetForm();
					}
				}
			},
			complete: () => {
				this.isDeletingAccordion = false;
				this.isLoadingAccordion = true;
				setTimeout(() => {
					this.isLoadingAccordion = false;
				}, 10);
			},
		});

		this.NotificationService.setNotificationMessage(this.labels.lbl_action_reload_page);
		location.reload();
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	backToHome(): void {
		this.resetForm();
		this.accordionFormDictionary = {};
	}
}
